'use client';

const dismissButtonText = "Dismiss message";
const VARIANT_PREFIX_MAP = {
  default: "Note",
  success: "Success",
  warning: "Warning",
  danger: "Error"
};
export {
  VARIANT_PREFIX_MAP,
  dismissButtonText
};
